import dayjs from "dayjs";

import CoreTrendsBarCell from "pro-features/components/core cells/src/CoreTrendsBarCell/CoreTrendsBarCell";
import type { ITrendsBarValue } from "pro-features/components/TrendsBar/src/TrendsBar";
import { i18nFilter } from "app/filters/i18nFilter";
import { abbrNumberFilter } from "app/filters/ngFilters";

const dateFormat = (date: string) => dayjs(date).format("MMM, YYYY");

export const CoreTrendsBarCellWrapper = ({ value }: FixmeType) => {
    if (value) {
        const data = Object.keys(value)
            .sort()
            .map((item) => ({
                value: value[item],
                tooltip: (
                    <span>
                        <strong>{`${abbrNumberFilter()(value[item])}`}</strong>
                        {` ${i18nFilter()("common.searches.in")} ${dateFormat(item)}`}
                    </span>
                ),
            })) as ITrendsBarValue[];
        return <CoreTrendsBarCell value={data} />;
    } else {
        return "N/A";
    }
};
